import React, { useEffect, useState } from 'react';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import { useHistory } from 'react-router-dom';
import { useForm } from "react-hook-form";
import "./style.sass";
import { InputTypeAndroid } from 'components/Forms/InputType';
import { BarraStepper } from 'components/Credito/BarraStepper';
import { useStorage64 } from 'hooks/useStorageBase64';
import { putRequestCard } from 'services/putRequestCard';
import { ModalErrorSolicitarCredito } from 'components/Error/ErrorSolicitarCredito'
import { dateFormatNumberInvert } from 'functions/dateFormat'
import { dataLayerButtons } from 'functions/dataLayerFunction'
import { useToken } from 'hooks/useToken'

import {repareTextCredit, removeAcentCredit } from 'functions/repareDataService'

export function InformacionFinancieraDesktop(props) {
    const { nextPage, cancelar, setNumFolio, setNombreTarjeta, setErrorC } = props;

    const history = useHistory();
    const [datosFinancieros, setDatosFinancieros] = useState(false);
    const [datos, setDatos] = useState();
    const [returnForm, SetReturnForm] = useState(false);

    const [crearTicket, setCrearTicket] = useState(false);
    const [infoPersonalStorage,] = useStorage64('infoPersonalStorage', '');
    const [infoTrabajoStorage,] = useStorage64('infoTrabajoStorage', '');
    const [, setInfoFinacieraStorage] = useStorage64('infoFinancieraStorage', '');

    const [pTieneTarjeta, setPtieneTarjeta] = useState(false);
    const [pTieneCreditoHipotecario, setPtienCreditoHipotecario] = useState(false);
    const [pCreditoAutomotriz, setPCreditoAutomotriz] = useState(false);
    const [permisos, setPermisos] = useState(false);

    const [inputUltimosDigitos, setInputUltimosDigitos] = useState();

    const [errorCode, setErrorCode] = useState();
    const [messageResponse, setMessageResponse] = useState();
    const [sectionActive, setSectionActive] = useState(null);
    const [showModalErr, setShowModalErr] = useState(false);


    const refreshCyR = useToken({firstActive: false, name: "infoFinDesk"})


    const { register, handleSubmit, errors } = useForm({
        defaultValues: {
            tieneTarjeta: datosFinancieros.tieneTarjeta,
            ultimosDigitos: datosFinancieros.ultimosDigitos,
            tieneCreditoHipotecario: datosFinancieros.tieneCreditoHipotecario,
            tieneCreditoAutomotriz: datosFinancieros.tieneCreditoAutomotriz,
            permisos: datosFinancieros.permisos
        }
    });

    // guarda la informacion enviada en el formulario
    const [tokenJWT, setTokenJWT] = useState(false)
    const sendFormInformacionFinanciera = data => {
        setDatos({
            "STarjeta": data.tieneTarjeta,
            "Digitos": data.ultimosDigitos,
            "SHipotecario": data.tieneCreditoHipotecario,
            "SAutomotriz": data.tieneCreditoAutomotriz,
            "Autorizacion": data.permisos
        })
        setTokenJWT(true)
        // console.log("datos financieros---- ", data)
    };

    useEffect(()=>{
        if(tokenJWT){
            refreshCyR.forceToken(true)
            setTokenJWT(false)
        }
    },[tokenJWT])

    useEffect(()=>{
        // console.log('refreshCyR.newToken: ', refreshCyR.newToken)
        if(refreshCyR.newToken){
            SetReturnForm(true);
        }
    },[refreshCyR.newToken])

    // al recibir data del formulario se guarda en variable datos financieros y se envia peticion al servicio
    useEffect(() => {
        if (returnForm) {
            let NombreFIX = repareTextCredit( String(infoPersonalStorage.Nombre).trim() );
            let APaternoFIX = repareTextCredit( String(infoPersonalStorage.APaterno).trim() );
            let AMaternoFIX = repareTextCredit( String(infoPersonalStorage.AMaterno).trim() );
            let DomicilioFIX = repareTextCredit( String( infoPersonalStorage.Domicilio?.substr(0,30) ).trim() );
            let ColoniaFIX = repareTextCredit( String(infoPersonalStorage.Colonia).trim() );
            let CiudadFIX = repareTextCredit( String( infoPersonalStorage.Ciudad?.substr(0,20) ).trim() );
            let EstadoFIX = repareTextCredit( String(infoPersonalStorage.Estado).trim() );
            let EmpresaFIX = repareTextCredit( String(infoTrabajoStorage.Empresa).trim() );
            let DireccionEmpleoFIX = repareTextCredit( String( infoTrabajoStorage.DireccionEmpleo).trim() );
            let ColoniaEmpFIX = repareTextCredit( String(infoTrabajoStorage.ColoniaEmp).trim() );
            let MunicipioEmpFIX = repareTextCredit( String( infoTrabajoStorage.MunicipioEmp?.substr(0,20) ).trim() );
            let EstadoEmpFIX = repareTextCredit( String(infoTrabajoStorage.EstadoEmp).trim() );
            let OcupacionFIX = repareTextCredit( String(infoTrabajoStorage.Ocupacion).trim() );


            let Tienda = infoPersonalStorage.Tienda;
            let Nombre = removeAcentCredit( NombreFIX );
            let APaterno = removeAcentCredit( APaternoFIX );
            let AMaterno = removeAcentCredit( AMaternoFIX );
            let Email = infoPersonalStorage.Email;
            let Celular = Number(infoPersonalStorage.Celular);
            let Telefono = Number(infoPersonalStorage.Celular);

            let Genero = infoPersonalStorage.Genero;
            let FechaNacimiento = Number(dateFormatNumberInvert(infoPersonalStorage.FechaNacimiento) );
            let RFC;
            if(infoPersonalStorage.RFC.length > 10){
                RFC = infoPersonalStorage.RFC;
            }else{
                RFC = `${infoPersonalStorage.RFC}XXX`;
            }
            let Domicilio = removeAcentCredit( DomicilioFIX );
            let CP = String(infoPersonalStorage.CP).trim();
            let Colonia = removeAcentCredit( ColoniaFIX );
            let Ciudad = removeAcentCredit( CiudadFIX );
            let Estado = removeAcentCredit( EstadoFIX );
            let TipoVivienda = infoPersonalStorage.TipoVivienda;
            let MontoRenta = Number(infoPersonalStorage.MontoRenta);
            let TiempoResAnio = Number(infoPersonalStorage.TiempoResAnio);
            let TiempoResMes = Number(infoPersonalStorage.TiempoResMes);
            let Nodependientes = Number(infoPersonalStorage.Nodependientes);

            let Empresa = removeAcentCredit( EmpresaFIX );
            let TipoEmpresa = infoTrabajoStorage.TipoEmpresa;
            let TelEmpresa = Number(infoTrabajoStorage.TelEmpresa);
            let Ext = Number(infoTrabajoStorage.Ext);
            let DireccionEmpleo = removeAcentCredit( DireccionEmpleoFIX );
            let CPEmp = String(infoTrabajoStorage.CPEmp).trim();
            let ColoniaEmp = removeAcentCredit( ColoniaEmpFIX );
            let MunicipioEmp = removeAcentCredit( MunicipioEmpFIX );
            let EstadoEmp = removeAcentCredit( EstadoEmpFIX );
            let Ocupacion = removeAcentCredit( OcupacionFIX );
            let TiempoEmpAnio = Number(infoTrabajoStorage.TiempoEmpAnio);
            let TiempoEmpMes = Number(infoTrabajoStorage.TiempoEmpMes);
            let Ingmensual = Number(infoTrabajoStorage.Ingmensual);
            let OtroIngresos = infoTrabajoStorage.OtroIngresos;
            let FuenteOtroIngresos = infoTrabajoStorage.FuenteOtroIngresos;

            let STarjeta = datos.STarjeta;
            let Digitos
            if(STarjeta === "SI"){
                Digitos = datos.Digitos;
            }else{
                Digitos = "0000"
            }
            let SHipotecario = datos.SHipotecario;
            let SAutomotriz = datos.SAutomotriz;
            let Autorizacion = datos.Autorizacion;

            setDatosFinancieros(datos);
            setInfoFinacieraStorage(datos);

            // console.log("datos para servicio----->", Tienda, "--", Nombre, "--", APaterno, "--", AMaterno, "--", Genero, "--", FechaNacimiento, "--",
            //     Telefono, "--", RFC, "--", Domicilio, "--", CP, "--", Colonia, "--",
            //     Ciudad, "--", Estado, "--", TipoVivienda, "--", MontoRenta, "--", TiempoResAnio, "--", TiempoResMes, "--", Nodependientes, "--", Celular, "--",
            //     Empresa, "--", TipoEmpresa, "--", TelEmpresa, "--", Ext, "--",
            //     DireccionEmpleo, "--", CPEmp, "--", ColoniaEmp, "--", MunicipioEmp, "--", EstadoEmp, "--", Ocupacion, "--", TiempoEmpAnio, "--",
            //     TiempoEmpMes, "--", Ingmensual, "--", OtroIngresos, "--", FuenteOtroIngresos,
            //     Email, "--", STarjeta, "--", Digitos, "--", SHipotecario, "--", SAutomotriz, "--", Autorizacion)

            putRequestCard({
                Tienda, Nombre, APaterno, AMaterno, Email,
                Genero, FechaNacimiento, Telefono, RFC, Domicilio, CP, Colonia, Ciudad, Estado,
                TipoVivienda, MontoRenta, TiempoResAnio, TiempoResMes, Nodependientes, Celular,
                Empresa, TipoEmpresa, TelEmpresa, Ext, DireccionEmpleo, CPEmp, ColoniaEmp, MunicipioEmp,
                EstadoEmp, Ocupacion, TiempoEmpAnio, TiempoEmpMes, Ingmensual, OtroIngresos, FuenteOtroIngresos,
                STarjeta, Digitos, SHipotecario, SAutomotriz, Autorizacion
            })
                .then(setCrearTicket)
            SetReturnForm(false);
        }
    }, [returnForm])

    // si la respuesta es ticket creado === 200 redirecciona a solicitud finalizada
    const [typeError, setTypeError] = useState('formShort')
    useEffect(() => {
        if (crearTicket) {
            if (Number(crearTicket.statusCode) === 200) {
                // console.log("ticket data-_> ", crearTicket, " ", crearTicket.data)
                setNumFolio(crearTicket.data);
                setNombreTarjeta(infoPersonalStorage.Nombre + " " + infoPersonalStorage.APaterno + " " + infoPersonalStorage.AMaterno);
                dataLayerButtons({eventName: "credito_enviarsolicitud"})
                nextPage(4);
            }
            else if (Number(crearTicket.statusCode) === 404) {
                setShowModalErr(true);
                setErrorCode(crearTicket.statusCode);
                setSectionActive('requestCredit');
            }
            else if (crearTicket.statusCode === 400) {
                let dataError = JSON.parse(crearTicket.data)
                if (dataError) {
                    setShowModalErr(true);
                    setSectionActive(null);
                    setErrorCode({ codMen: dataError?.codMen });
                    setTypeError('formShort')
                }
            }
            else if(crearTicket.statusCode >= 500){
                setErrorC(crearTicket.statusCode)
            }
        }
    }, [crearTicket])

    const seleccionarTieneTarjeta = (e) => {
        setPtieneTarjeta(e.target.value);
    };
    const seleccionarTieneCreditoHipotecario = (e) => {
        setPtienCreditoHipotecario(e.target.value);
    };
    const seleccionarCreditoAutomotriz = (e) => {
        setPCreditoAutomotriz(e.target.value);
    };
    const seleccionarPermisos = (e) => {
        setPermisos(e.target.value);
    };

    const valTieneTarjeta = {
        required: 'Campo obligatorio',
    };
    const valUltimosDigitos = {
        required: 'Campo obligatorio',
        minLength: {
            value: 4,
            message: 'Faltan dígitos. Debe ser de al menos 4 dígitos'
        },
        maxLength: {
            value: 4,
            message: 'Debe contener máximo 4 dígitos'
        }
    };
    const valTieneCreditoHipotecario = {
        required: 'Campo obligatorio',
    };
    const valCreditoAutomotriz = {
        required: 'Campo obligatorio',
    };
    const valPermisos = {
        required: 'Campo obligatorio',
    };

    // valida creacion de ticket y si no pasa manda el error
    const handleCloseErr = () => {
        setShowModalErr(false);
        if (sectionActive === 'requestCredit') {
            history.replace(`${BASE_PATH}${SUB_DIRECTORY}home`);
        }
    }

    return (
        <>
            <BarraStepper itemActivo={3} />

            <form onSubmit={handleSubmit(sendFormInformacionFinanciera)}>
                <div className="infoFinancieraFrom">
                    <div className="infoPersonalGeneral">
                        <div className="tituloSeccion">
                            <p>Contesta algunas preguntas</p>
                        </div>

                        <div className="secFinanciero">
                            <div className="campo">
                                <div className="subCampo">
                                    <p>¿Cuentas con tarjeta bancaria?</p>

                                    <ul className={pTieneTarjeta === false && errors.tieneTarjeta && errors.tieneTarjeta.message ? "ulPreguntas conError" : "ulPreguntas"} onChange={seleccionarTieneTarjeta}>
                                        <li id="negativo">
                                            <input className="radio" id="si" type="radio" value="SI" name="tieneTarjeta" checked={pTieneTarjeta === "SI" ? true : false} ref={register(valTieneTarjeta)} />
                                            <label name="si" htmlFor="si"> Si </label>
                                        </li>
                                        <li id="positivo">
                                            <input className="radio" id="no" type="radio" value="NO" name="tieneTarjeta" checked={pTieneTarjeta === "NO" ? true : false} ref={register(valTieneTarjeta)} />
                                            <label name="no" htmlFor="no"> No </label>
                                        </li>
                                    </ul>

                                    {pTieneTarjeta === false && errors.tieneTarjeta && errors.tieneTarjeta.message
                                        ? <div className="error">Campo obligatorio</div>
                                        : null
                                    }
                                </div>
                            </div>
                            
                            <div className="campo">
                                <div className="subCampo">
                                    {pTieneTarjeta === "SI"
                                        ? 
                                            <div className="boxCompletar">
                                                <InputTypeAndroid
                                                    type="text"
                                                    name="ultimosDigitos"
                                                    id="ultimosDigitos"
                                                    placeholder="Últimos 4 números de ella"
                                                    refs={register(valUltimosDigitos)}
                                                    className="desktopInput"
                                                    autocomplete='ultimosDigitos'
                                                    setNumero={setInputUltimosDigitos}
                                                    value={inputUltimosDigitos}
                                                    errorMessage={errors.ultimosDigitos && errors.ultimosDigitos.message}
                                                    pattern={'number'}
                                                    maxLength={4}
                                                />
                                            </div>
                                        : null
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="secFinanciero">
                            <div className="campo">
                                <div className="subCampo">
                                    <p className="mtopT">¿Cuentas con un crédito hipotecario bancario?</p>

                                    <ul className={pTieneCreditoHipotecario === false && errors.tieneCreditoHipotecario && errors.tieneCreditoHipotecario.message ? "ulPreguntas conError" : "ulPreguntas"} onChange={seleccionarTieneCreditoHipotecario}>
                                        <li id="negativo">
                                            <input className="radio" id="si" type="radio" value="SI" name="tieneCreditoHipotecario" checked={pTieneCreditoHipotecario === "SI" ? true : false} ref={register(valTieneCreditoHipotecario)} />
                                            <label name="si" htmlFor="si"> Si </label>
                                        </li>
                                        <li id="positivo">
                                            <input className="radio" id="no" type="radio" value="NO" name="tieneCreditoHipotecario" checked={pTieneCreditoHipotecario === "NO" ? true : false} ref={register(valTieneCreditoHipotecario)} />
                                            <label name="no" htmlFor="no"> No </label>
                                        </li>
                                    </ul>

                                    {pTieneCreditoHipotecario === false && errors.tieneCreditoHipotecario && errors.tieneCreditoHipotecario.message
                                        ? <div className="error">Campo obligatorio</div>
                                        : null
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="secFinanciero">
                            <div className="campo">
                                <div className="subCampo">
                                    <p className="mtopT">¿Has ejercido algún crédito automotriz bancario en los últimos 24 meses?</p>

                                    <ul className={pCreditoAutomotriz === false && errors.tieneCreditoAutomotriz && errors.tieneCreditoAutomotriz.message ? "ulPreguntas conError" : "ulPreguntas"} onChange={seleccionarCreditoAutomotriz}>
                                        <li id="negativo">
                                            <input className="radio" id="si" type="radio" value="SI" name="tieneCreditoAutomotriz" checked={pCreditoAutomotriz === "SI" ? true : false} ref={register(valCreditoAutomotriz)} />
                                            <label name="si" htmlFor="si"> Si </label>
                                        </li>
                                        <li id="positivo">
                                            <input className="radio" id="no" type="radio" value="NO" name="tieneCreditoAutomotriz" checked={pCreditoAutomotriz === "NO" ? true : false} ref={register(valCreditoAutomotriz)} />
                                            <label name="no" htmlFor="no"> No </label>
                                        </li>
                                    </ul>

                                    {pCreditoAutomotriz === false && errors.tieneCreditoAutomotriz && errors.tieneCreditoAutomotriz.message
                                        ? <div className="error">Campo obligatorio</div>
                                        : null
                                    }
                                </div>
                            </div>
                        </div>

                        <div className="secFinanciero">
                            <div className="campo">
                                <p className="copyAviso mtopT">¿Autorizas a Claroshop.com, S.A. de C.V. a que consulte antecedentes crediticios en alguna sociedad de información crediticia, declarando que conoces la naturaleza, alcance y uso de Claroshop.com, S.A. de C.V. le dará a esta información?</p>
                                <p className="copyAviso">Reconozco haber leído y aceptado los términos y condiciones del <a className="linkSub" href={`${BASE_PATH}contrato-credito/`} target="_blank" rel="noopener noreferrer">Aviso de Privacidad</a>.</p>

                                <ul className={permisos === false && errors.permisos && errors.permisos.message ? "ulPreguntas conError" : "ulPreguntas"} onChange={seleccionarPermisos}>
                                    <li id="autorizaSears" className="liAutorizacion">
                                        <input className="radio" id="permisos" type="checkbox" value="SI" name="permisos" ref={register(valPermisos)} />
                                        <label name="permisos" htmlFor="permisos" className="acepto"> Si, Acepto </label>
                                    </li>
                                </ul>

                                {permisos === false && errors.permisos && errors.permisos.message
                                    ? <div className="error">Campo obligatorio</div>
                                    : null
                                }
                            </div>
                        </div>
                    </div>
                </div>

                <div className="botones">
                    <button className="btnRedCard">Continuar</button>
                    <button className="btnWhite" onClick={cancelar}>Cancelar</button>
                </div>
            </form>


            {showModalErr &&
                <ModalErrorSolicitarCredito
                    errorCode={errorCode}
                    section={typeError}
                    handleClose={handleCloseErr}
                />
            }
        </>
    )
}